import { useEffect, useState } from 'react'
import { TASK_TICK_EVENT } from '../api/taskTicks'

/** Перерисовывать компонент на каждый ответ опроса статуса генерации (api/taskTicks) — только пока active: страница
 *  генерации большая, без генерации перерисовки на чужие опросы (стикеры, история) ей не нужны. */
export function useTaskTicks(active = true): number {
	const [n, setN] = useState(0)
	useEffect(() => {
		if (!active) return
		const on = () => setN((x) => x + 1)
		window.addEventListener(TASK_TICK_EVENT, on)
		return () => window.removeEventListener(TASK_TICK_EVENT, on)
	}, [active])
	return n
}
